export const linkParticipantSampleMutation = `
mutation linkParticipantSample($participantId: String!, $sampleBarcode: String!) {
    linkParticipantSample(participantId: $participantId, sampleBarcode: $sampleBarcode) {
        sampleLinkDate
    },
}`;
